import React, { useState, useEffect, useRef } from "react";
import stats1 from "../../../../assets/assests/stats.png";
import stats2 from "../../../../assets/assests/stats1.png";
import stats3 from "../../../../assets/assests/stats2.png";
import TableComponent from "./datatables";
import TicketsStatsComponent from "./tickects-stats";
import StatsOverViewComponent from "./stats-overview";
import TeamPerformanceChart from "./team-chart";
import OverAllChart from "./overall-chart";
import MachineUsageChart from "./machine-usage-chart";
import { axiosApi } from "../../../services/axios_api";
import Spinner from "../../components/spinner";
import { Button } from "primereact/button";
import CashFlowChart from "./cash-flow-chart";
import MachineHealth from "./machine-health";
import moment from "moment";

const Dashboard = ({}) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
  const twoMonthsAgo = previousMonth === 1 ? 12 : previousMonth - 1;

  const [loading, setLoading] = useState(false);
  const [monthsList, setMonthsList] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const [activeChart, setActiveChart] = useState(null);
  const [overviewDate, setOverviewDate] = useState(new Date());
  const [month1, setMonth1] = useState(twoMonthsAgo);
  const [month2, setMonth2] = useState(previousMonth);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [weeklyDate, setWeeklyDate] = useState(new Date());

  const [dashboardStatsData, setDashboardStatsData] = useState({
    kiosksStatus: null,
    kiosksOverview: null,
    monthlyCollection: null,
    weeklyCollection: null,
  });

  const handleChartSelection = (chart, ref) => {
    setActiveChart(chart);

    setTimeout(() => {
      if (ref?.current) {
        ref.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 200);
  };

  const collectionRef = useRef(null);
  const machineUsageRef = useRef(null);
  const cashFlowRef = useRef(null);

  useEffect(() => {
    const fetchMonths = async () => {
      setLoading(true);
      try {
        const response = await axiosApi.get("/Portal/lists/months");

        if (response.data && response.data.body) {
          const formattedMonths = response.data.body.map((month) => ({
            label: month.fullName,
            value: month.id,
          }));
          setMonthsList(formattedMonths);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMonths();
  }, []);

  const getDashboardData = async () => {
    setLoading(true);
    try {
      const payload = {
        fromDate: "2025-02-09",
        toDate: "2025-02-09",
        month1: 12,
        month2: 1,
        month3: 2,
        daysInterval: 0,
        kioskStatusOverviewDate: "2025-02-09",
        teamPerformanceDate: "2025-02-09",
        overallCollectionDate: "2025-02-09",
        selectedKioskId: "string",
      };

      const response = await axiosApi.post("/Portal/dashboard/admin", payload);
      setDashboardData(response.data?.body ?? {});
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getKioskStatusCount = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/dashboard/kiosks-status-count`
      );
      setDashboardStatsData((prev) => ({
        ...prev,
        kiosksStatus: response.data.body,
      }));
    } catch (error) {
      console.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const getKioskStatusOverview = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/dashboard/kiosks-status-overview`,
        {
          params: {
            date: overviewDate
              ? moment(overviewDate).format("YYYY-MM-DD")
              : null,
          },
        }
      );
      setDashboardStatsData((prev) => ({
        ...prev,
        kiosksOverview: response.data.body,
      }));
    } catch (error) {
      console.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const getKioskMonthlyCollection = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/dashboard/monthly-collection`,
        {
          params: { month1, month2, month3: selectedMonth },
        }
      );
      setDashboardStatsData((prev) => ({
        ...prev,
        monthlyCollection: response.data.body,
      }));
    } catch (error) {
      console.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const getKioskWeeklyCollection = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/dashboard/weekly-collection`,
        {
          params: {
            date: weeklyDate ? moment(weeklyDate).format("YYYY-MM-DD") : null,
          },
        }
      );
      setDashboardStatsData((prev) => ({
        ...prev,
        weeklyCollection: response.data.body,
      }));
    } catch (error) {
      console.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDashboardData();
    getKioskStatusCount();
  }, []);

  useEffect(() => {
    getKioskStatusOverview();
  }, [overviewDate]);

  useEffect(() => {
    getKioskWeeklyCollection();
  }, [weeklyDate]);

  useEffect(() => {
    getKioskMonthlyCollection();
  }, [month1, month2, selectedMonth]);

  const tilesData = [
    {
      title: "Total KIOSKs",
      key: "totalKiosks",
      backgroundImage: stats1,
    },
    {
      title: "Active KIOSKs",
      key: "activeKiosks",
      backgroundImage: stats3,
    },
    {
      title: "Inactive KIOSKs",
      key: "inActiveKiosks",
      backgroundImage: stats2,
    },
  ];

  const buttonTiles = [
    {
      id: "collection",
      label: "Overall Collection",
      icon: "pi pi-chart-bar",
      ref: collectionRef,
    },
    {
      id: "machineUsage",
      label: "Machine Overview",
      icon: "pi pi-cog",
      ref: machineUsageRef,
    },
    {
      id: "cashFlow",
      label: "Cash Flow Summary",
      icon: "pi pi-money-bill",
      ref: cashFlowRef,
    },
  ];

  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
      <div className="dashboard m-0 p-0">
        <div className="p-fluid grid m-0">
          <div className=" field col-12 md:col-6 lg:col-4">
            <div className="card  h-full flex flex-col">
              <div className="titles-grid mb-2">
                {tilesData.map((tile, index) => (
                  <div
                    key={index}
                    className="tiles"
                    style={{ backgroundImage: `url(${tile.backgroundImage})` }}
                  >
                    <h4>{tile.title}</h4>
                    <h2>
                      {dashboardStatsData.kiosksStatus
                        ? dashboardStatsData.kiosksStatus[tile.key]
                        : "--"}
                    </h2>
                  </div>
                ))}
              </div>

              <div className="p-fluid button-titles-grid">
                {buttonTiles.map((tile) => (
                  <div className="tile" key={tile.id}>
                    <div className="button-container">
                      <Button
                        className={`custom-button ${
                          activeChart === tile.id ? "active" : ""
                        }`}
                        onClick={() => handleChartSelection(tile.id, tile.ref)}
                      >
                        <div className="icon-wrapper">
                          <i className={tile.icon}></i>
                        </div>
                        <span>{tile.label}</span>
                      </Button>
                    </div>
                  </div>
                ))}
              </div>

              <StatsOverViewComponent
                dashboardStatsData={dashboardStatsData.kiosksOverview}
                loading={loading}
                overviewDate={overviewDate}
                setOverviewDate={setOverviewDate}
              />
            </div>
          </div>

          <div className="field col-12 md:col-6 lg:col-8">
            <div className="card  h-full flex flex-col">
              <TableComponent
                monthsList={monthsList}
                dashboardStatsData={dashboardStatsData} 
                loading={loading}
                month1={month1}
                setMonth1={setMonth1}
                month2={month2}
                setMonth2={setMonth2}
                currentMonth={selectedMonth}
                setCurrentMonth={setSelectedMonth}
                weeklyDate={weeklyDate}
                setWeeklyDate={setWeeklyDate}
              />
              <TicketsStatsComponent
                dashboardData={dashboardData}
                loading={loading}
              />
              <TeamPerformanceChart
                dashboardData={dashboardData}
                loading={loading}
              />
            </div>
          </div>
        </div>

        {activeChart === "collection" && (
          <div className="p-fluid grid">
            <div ref={collectionRef} className="field col-12 md:col-12">
              <div className="card">
                <OverAllChart
                  dashboardData={dashboardData}
                  loading={loading}
                  monthsList={monthsList}
                />
              </div>
            </div>
          </div>
        )}

        {activeChart === "machineUsage" && (
          <div className="card">
            <div className="p-fluid grid" ref={machineUsageRef}>
              <div className="field col-12 md:col-8">
                <MachineUsageChart
                  dashboardData={dashboardData}
                  loading={loading}
                />
              </div>
              <div className="field col-12 md:col-4">
                <div className="card">
                  <MachineHealth
                    dashboardData={dashboardData}
                    loading={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {activeChart === "cashFlow" && (
          <div className="p-fluid grid">
            <div ref={cashFlowRef} className="field col-12 md:col-12">
              <div className="card">
                <CashFlowChart
                  dashboardData={dashboardData}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Dashboard;
